import { Link, NavLink } from "react-router-dom";
import MainSlide from "../../components/Home/MainSlide";
import * as S from "./styled";
import HomeArrowRightIcon from "../../assets/images/home/mainSlideArrowRight.png";
import Icon from "../../components/Icon";
import ContentsTitle from "../../components/Home/ContentsTitle";
import ContentsSlide from "../../components/Home/ContentsSlide";
import NoticeSlide from "../../components/Home/NoticeSlide";
import { useEffect } from "react";
import AOS from "aos";
import Popup from "../../components/Popup";
import { Helmet } from "react-helmet-async";

const Home = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      AOS.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>IPDIA 국제실용댄스지도자협회</title>

        <meta
          name="description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />

        <meta
          name="keywords"
          content="IPDIA, 아이피디아, 국제실용댄스지도자협회, 국제실용댄스, 셔플댄스, 댄스협회, 댄스자격증, 실용무용, 댄스강사자격증"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ipdiakorea.com" />
        <meta
          property="og:image"
          content="https://ipdiakorea.com/og-image.png"
        />
      </Helmet>
      <div>
        <MainSlide />
        <S.HomeMenuWrapper>
          <div className="inner">
            <S.HomeMainWrap>
              <li
                data-aos="fade-up"
                data-aos-duration={600}
                data-aos-easing="linear"
                data-aos-delay={100}
              >
                <NavLink to="/aboutus">
                  <div>
                    <h6>협회 소개</h6>
                    <p>Introduction</p>
                  </div>
                  <Icon>
                    <img src={HomeArrowRightIcon} alt="logo" />
                  </Icon>
                </NavLink>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration={600}
                data-aos-easing="linear"
                data-aos-delay={200}
              >
                <NavLink to="/info">
                  <div>
                    <h6>협회 지부 안내</h6>
                    <p>
                      Branch <br className="xl-br" />
                      Information
                    </p>
                  </div>
                  <Icon>
                    <img src={HomeArrowRightIcon} alt="logo" />
                  </Icon>
                </NavLink>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration={600}
                data-aos-easing="linear"
                data-aos-delay={300}
              >
                <NavLink to="/education">
                  <div>
                    <h6>교육 안내</h6>
                    <p>
                      Education <br className="xl-br" />
                      Information
                    </p>
                  </div>
                  <Icon>
                    <img src={HomeArrowRightIcon} alt="logo" />
                  </Icon>
                </NavLink>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration={600}
                data-aos-easing="linear"
                data-aos-delay={400}
              >
                <NavLink to="/qualifications">
                  <div>
                    <h6>지도자 자격증</h6>
                    <p>
                      Instructor <br className="xl-br" />
                      Certification
                    </p>
                  </div>
                  <Icon>
                    <img src={HomeArrowRightIcon} alt="logo" />
                  </Icon>
                </NavLink>
              </li>
            </S.HomeMainWrap>
          </div>
        </S.HomeMenuWrapper>
        <S.HomeContentsContainer>
          <S.HomeContentsWrapper>
            <div className="inner">
              <S.HomeContentsWrap>
                <ContentsTitle title="협회 활동" />
                <ContentsSlide />
              </S.HomeContentsWrap>
            </div>
          </S.HomeContentsWrapper>
          <S.HomeNoticeWrapper>
            <div className="inner">
              <S.HomeNoticeWrap>
                <ContentsTitle title="공지사항" />
                <NoticeSlide />
              </S.HomeNoticeWrap>
            </div>
          </S.HomeNoticeWrapper>
        </S.HomeContentsContainer>

        <Popup />
      </div>
    </>
  );
};

export default Home;
